import { render, staticRenderFns } from "./WideYesNo.vue?vue&type=template&id=0d12212c&scoped=true&"
import script from "./WideYesNo.vue?vue&type=script&lang=js&"
export * from "./WideYesNo.vue?vue&type=script&lang=js&"
import style0 from "./WideYesNo.vue?vue&type=style&index=0&id=0d12212c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d12212c",
  null
  
)

export default component.exports